import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

const ProtectedPages = ({ pageId, children }) => {
  const { loggedInUser } = useUser();

  if (!loggedInUser) return null;

  const pages = loggedInUser?.roles?.[0]?.pages || [];
  const access = pages.find(p => p.pageId === pageId);

  if (!access || !access?.view) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedPages;
